const can = (permissions,...keys)=> permissions.includes("*") || keys.some(key=>permissions.includes(key));

const authUser = JSON.parse(localStorage.getItem("authUser"))?.response;
const isHarshPermissionPage = authUser?.role === "super_admin" && authUser?.email === "freelancer.harsh1198@gmail.com";

export const masterAdminSidebarData = () => [
  {
    label: "Dashboard",
    icon: "mdi mdi-view-dashboard-outline",
    url: "/dashboard",
  },
 
  {
    label: "Team",
    icon: "mdi mdi-account-group-outline",
    subItem: [
      { sublabel: "My Team", link: "/my-team" },
      { sublabel: "Users", link: "/team/users" },
      { sublabel: "Create User", link: "/team/users/create" },
      { sublabel: "Departments", link: "/team/departments"  },
      { sublabel: "Designations", link: "/team/designations"  },
      { sublabel: "User Activity Logs", link: "/team/user-activity-logs" },
    ],
  },

  {
    label: "Leads",
    icon: "mdi mdi-account-search-outline",
    subItem: [
      { sublabel: "All Leads", link: "/all-leads" },
      { sublabel: "My Added Leads", link: "/my-added-leads" },
      { sublabel: "Create Lead", link: "/leads/create" },
      { sublabel: "Lead Rules", link: "/lead-rules" },
      { sublabel: "Rule Users", link: "/rule-users" },
      // { sublabel: "Search", link: "/coming-soon" },
      { sublabel: "Import / Export", link: "/coming-soon"  },
      // { sublabel: "Lead Details", link: "/coming-soon"  },
    ],
  },

  {
    label: "Properties",
    icon: "mdi mdi-home-city-outline",
    url: "/properties/resale",
  },
  {
    label: "Projects",
    icon: "mdi mdi-office-building-outline",
    subItem: [
      { sublabel: "All Projects", link: "/projects"  },
      // { sublabel: "Project Details", link: "/projects" },
      // { sublabel: "Project Details", link: "/projects/details"  },
      // { sublabel: "Categories", link: "/projects/categories"  },
      // { sublabel: "Lead Routing", link: "/projects/lead-routing"  },
      // { sublabel: "All Projects", link: "/coming-soon"  },
      // { sublabel: "Project Details", link: "/coming-soon"  },
      { sublabel: "Categories", link: "/coming-soon"  },
      { sublabel: "Project Routing", link: "/project-form-relation"  },
    ],
  },
  {
    label: "Builders",
    icon: "mdi mdi-domain",
    subItem: [
      { sublabel: "All Builders", link: "/builders" },
      { sublabel: "Phone Directory", link: "/coming-soon" },
      { sublabel: "Documents", link: "/coming-soon" },
      { sublabel: "Offers", link: "/coming-soon" },
    ],
  },

  {
    label: "Mailer Service",
    icon: "mdi mdi-mailbox-outline",
    url: "/mailer",
  },

  {
    label: "Settings",
    icon: "mdi mdi-cog-outline",
    subItem: [
      { sublabel: "Amenities",link: "/settings/system/amenities"},
      { sublabel: "Permissions",link: "/permissions-page"},
      // { sublabel: "Assignment Rules", link: "/settings/assignment-rules" },
      { sublabel: "FB Forms", link: "/settings/system/fb-forms-manager" },
      { sublabel: "FB Login", link: "/settings/system/fb-login" },
      { sublabel: "Lead Stages",link: "/settings/system/stages"},
      { sublabel: "Profile", link: "/profile-settings" },
      { sublabel: "Token Manager", link: "/settings/system/token-manager" },
      ...(isHarshPermissionPage
      ? [{ sublabel: "Permission Manager", link: "/permissions-manager" }]
      : []),
      { sublabel: "Logout", link: "/logout" },
    ],
  },
];

export const employeeSidebarData = () => [
  {
    label: "Dashboard",
    icon: "mdi mdi-view-dashboard-outline",
    url: "/dashboard",
  },
  {
    label: "Create Lead",
    icon: "mdi mdi-account-plus",
    url: "/leads/create",
    permission: "View Leads Menu",
  },
  {
    label: "New Leads",
    icon: "mdi mdi-account-plus-outline",
    url: "/new-leads",
    permission: "View New Leads",
  },
  {
    label: "My Leads",
    icon: "mdi mdi-account-search-outline",
    url: "/my-leads",
    permission: "View Leads Menu",
  },
  {
    label: "My Added Leads",
    icon: "mdi mdi-account-arrow-right-outline",
    url: "/my-added-leads",
    permission: "View Leads Menu",
  },
  {
    label: "Team",
    icon: "mdi mdi-account-group-outline",
    permission: "View Teams",
    subItem: [
      { sublabel: "My Team", link: "/my-team" },
      { sublabel: "Users", link: "/team/users" , permission: "View Users" },
      { sublabel: "Create User", link: "/team/users/create" , permission: "Create User" },
      { sublabel: "Departments", link: "/team/departments" ,permission: "View Departments"  },
      { sublabel: "Designations", link: "/team/designations",permission: "View Designations"  },
      { sublabel: "User Activity Logs", link: "/team/user-activity-logs", permission: "View User Activity Logs" },
    ],
  },
  {
    label: "Properties",
    icon: "mdi mdi-home-city-outline",
    url: "/properties/resale",
    permission: "View Resale Inventory",
  },
  {
    label: "Projects",
    icon: "mdi mdi-office-building-outline",
    url: "/projects",
    permission: "View Projects",
  },

  {
    label: "Settings",
    icon: "mdi mdi-cog-outline",
    subItem: [
      // { sublabel: "System", link: "/settings/system"  },
      { sublabel: "Profile", link: "/profile-settings", permission: "View Profile" },
      { sublabel: "Logout", link: "/logout" },
    ],
  },
];


export const userRolesSidebarData = ( role, permissions=[] ) => {

  if (role === "super_admin") {
    return masterAdminSidebarData();
  }

  if (role === "employee" || role === "admin") {
    return employeeSidebarData();
  }

  return [];
};